export default __webpack_public_path__ + "static/media/sidekiq.1dcf5579.svg";